module.exports = __webpack_public_path__ + "img/ROROCCCO01280409.4d657334.png";